import { render, staticRenderFns } from "./LiveWaitStatusLegend.vue?vue&type=template&id=7826e5b0&scoped=true"
import script from "./LiveWaitStatusLegend.vue?vue&type=script&lang=js"
export * from "./LiveWaitStatusLegend.vue?vue&type=script&lang=js"
import style0 from "./LiveWaitStatusLegend.vue?vue&type=style&index=0&id=7826e5b0&prod&scoped=true&lang=css"
import style1 from "./LiveWaitStatusLegend.vue?vue&type=style&index=1&id=7826e5b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826e5b0",
  null
  
)

export default component.exports